<template>
  <!-- begin:: Footer -->
  <div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
    <div
      class="d-flex align-items-center justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="text-dark">
        <span class="text-muted font-weight-bold mr-2">2020 &nbsp;&copy;&nbsp;</span>
        <a
          href="https://stroitaxi.su"
          target="_blank"
          class="text-dark-75 text-hover-primary"
        >СтройТакси</a>
      </div>
      <div class="nav nav-dark">
        <a href="https://stroitaxi.com/o-nas" target="_blank" class="nav-link pr-3 pl-0">О нас</a>
        <a href=" https://stroitaxi.com/podryadchikam" target="_blank" class="nav-link pr-3 pl-0">Подрядчикам</a>
        <a href="https://stroitaxi.com/zakazchikam" target="_blank" class="nav-link pr-3 pl-0">Заказчикам</a>
        <a href="https://stroitaxi.com/franshiza" target="_blank" class="nav-link pr-3 pl-0">Открыть филиал</a>
        <a href="https://stroitaxi.com/kontakty" target="_blank" class="nav-link pl-3 pr-0">Контакты</a>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    }
  }
};
</script>
